import { useEffect, useState } from 'react'
import { useTheme } from '../context/ThemeContext'
import { gradientPresets, photoWallpapers, DEFAULT_WALLPAPER } from '../theme/wallpapers'

// Helper to find gradient classes
const getGradientClasses = (id) => gradientPresets.find(g => g.id === id)?.classes || gradientPresets[0].classes
// Helper to find photo src
const getPhotoSrc = (id) => photoWallpapers.find(p => p.id === id)?.src

const Background = () => {
  const { wallpaperKind: kind, wallpaperValue: value } = useTheme()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (kind === 'photo' || kind === 'custom') {
      const img = new Image()
      const src = kind === 'photo' ? getPhotoSrc(value) : value // custom holds dataURL
      if (!src) return
      img.onload = () => setLoaded(true)
      img.src = src
    } else {
      setLoaded(true)
    }
  }, [kind, value])

  const gradientLayer = (
    <div className={`absolute inset-0 ${getGradientClasses(kind === 'gradient' ? value : DEFAULT_WALLPAPER.value)} transition-opacity duration-700`} />
  )

  const photoSrc = kind === 'photo' ? getPhotoSrc(value) : kind === 'custom' ? value : null

  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Only show gradient layer when NOT using photo wallpapers */}
      {!photoSrc && gradientLayer}
      {photoSrc && (
        <div
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          style={{ backgroundImage: `url('${photoSrc}')` }}
        />
      )}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="h-64 w-64 rounded-full bg-blue-500 opacity-10 blur-3xl"></div>
      </div>
    </div>
  )
}

export default Background